<template>
  <div class="auth_wrapper">
    <div v-if="false" class="auth-loader">
<!--      <BaseLoader />-->
    </div>
    <div v-else class="auth_content">
        <div v-if="envName === 'prima'" style="display: flex; align-items: center; justify-content: center; gap: 8px">
          <img src="@/assets/prima/images/prima-text.png" alt="prima" />
        </div>
        <a v-else-if="envName !== 'grok'" :href="authLogoHref" class="auth_title auth_title_link" style="display: flex; align-items: center; justify-content: center; gap: 8px">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.9964 8.37513H17.7618C15.7911 8.37859 14.1947 9.93514 14.1911 11.8566C14.1884 13.7823 15.7867 15.3458 17.7618 15.3484H22V15.6543C22 19.0136 19.9636 21 16.5173 21H7.48356C4.03644 21 2 19.0136 2 15.6543V8.33786C2 4.97862 4.03644 3 7.48356 3H16.5138C19.96 3 21.9964 4.97862 21.9964 8.33786V8.37513ZM6.73956 8.36733H12.3796H12.3831H12.3902C12.8124 8.36559 13.1538 8.03019 13.152 7.61765C13.1502 7.20598 12.8053 6.87318 12.3831 6.87491H6.73956C6.32 6.87664 5.97956 7.20858 5.97778 7.61852C5.976 8.03019 6.31733 8.36559 6.73956 8.36733Z" fill="var(--accent-bg)"/>
            <path opacity="0.4" d="M16.0374 12.2966C16.2465 13.2478 17.0805 13.917 18.0326 13.8996H21.2825C21.6787 13.8996 22 13.5715 22 13.166V10.6344C21.9991 10.2297 21.6787 9.90077 21.2825 9.8999H17.9561C16.8731 9.90338 15.9983 10.8024 16 11.9102C16 12.0398 16.0128 12.1695 16.0374 12.2966Z" fill="var(--accent-bg)"/>
            <circle cx="18" cy="11.8999" r="1" fill="var(--accent-bg)"/>
          </svg>
          <span>E-Wallet</span>
        </a>
<!--        <div v-else-if="envName === 'prima'" class="auth_title" style="display: flex; align-items: center; justify-content: center">-->
<!--          <span>Prima Bank</span>-->
<!--        </div>-->
        <div :class="`auth_title ${ $route.name !== 'AuthIn' ?'auth_title_mobile':''}`">
          <template v-if="envName === 'grok'">
            <img src="@/assets/grok/images/logo.svg" alt="">
          </template>
<!--          <template v-else-if="stater">-->
<!--            <img src="@/assets/stater/images/wallet.svg" alt="">-->
<!--            <span>E-Wallet</span>-->
<!--          </template>-->
        </div>
        <router-view/>
    </div>
    <div
      v-if="envName !== 'cmp'"
      class="auth_bg splash"
      :class="envName"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { envName } from '@/plugins/utils.js'

  const authLogoHref = computed(() => {
    if (envName !== 'wca' || typeof window === 'undefined') {
      return '/'
    }

    const { protocol, hostname, port } = window.location
    const landingHostname = hostname.replace(/^app\./, '')
    return `${protocol}//${landingHostname}${port ? `:${port}` : ''}/`
  })

  // import { computed, defineAsyncComponent } from "vue";
  // import { doRegister } from "@/services/api"
  //
  // const BaseLoader = defineAsyncComponent (() => import(/* webpackChunkName: "components/base/BaseLoader" */ '@/components/base/BaseLoader.vue'))
  //
  // import { useAuthStore } from '@/store/stores/auth'
  // const authStore = useAuthStore()

  // const authLoaderActive = computed(() => authStore.loader)
  // const telegramContact = computed(() => authStore.telegramContact)
  //
  // if (telegramContact.value) {
  //   const registerData = {
  //     "first_name": telegramContact.value.first_name,
  //     "last_name": telegramContact.value.first_name,
  //     "phone": telegramContact.value.phone_number,
  //     "email": `${telegramContact.value.phone_number}@mail.tg`,
  //     "captcha_token": captchaToken
  //   }
  //
  //   doRegister(registerData).then((resp) => {
  //     if (resp.status === "error") {
  //       // this.errorMessage = resp.message
  //     } else {
  //
  //     }
  //   })
  // }


</script>

<style lang="scss">
@use "@/assets/styles/variables" as *;

.auth_wrapper {
  width: 100%;
  max-width: 1164px;
  padding: 32px;
  min-height: 100dvh;
  margin: 0 auto;
  display: flex;
  gap: 24px;
  position: relative;
  align-items: stretch;
  justify-content: center;

  @media (max-width: $mobile-breakpoint) {
    height: auto;
    padding: 0;
  }

  .auth-loader {
    width: 100%;
    height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.auth_content {
  flex-basis: 100px;
  flex-grow: 1;
  position: relative;
  height: 100%;
  max-width: 538px;
  border-radius: 16px;
  border: 1px solid var(--layout-bg-lighter);
  background: var(--layout-bg);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100dvh - 64px);

  @media (max-width: $mobile-breakpoint) {
    min-height: auto;
    justify-content: flex-start;
  }
}

.auth_wrapper .auth_content .register {
  width: 100%;
  max-width: 465px;
}

.auth_wrapper .auth_content .auth_title {
  display: flex;
  gap: 8px;
  align-items: center;
}
.auth_wrapper .auth_content .auth_title_link {
  color: inherit;
  cursor: pointer;
  text-decoration: none;
}
.auth_wrapper .auth_content .auth_title span {
  color: var(--text-color-accent);
  font-family: "Rubik", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.88px;
}

.auth_wrapper .auth_content .log_in .title {
  color: #FFF;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
  letter-spacing: 0.4px;
  margin: 50px auto 30px;
}
.auth_wrapper .auth_content .log_in .text {
  color: #6C7072;
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 12px auto 12px;
  max-width: 327px;
  margin-right: 8px;
}
.auth_wrapper .auth_content .log_in .main_btn {
  width: 335px;
}
.auth_wrapper .auth_content .log_in .identifiction .link_text_wrapper {
  margin: 50px 0 16px;
  max-width: 335px;
  display: flex;
  justify-content: center;
}
.auth_wrapper .auth_content .log_in .identifiction .link_text_wrapper button {
  display: flex;
  gap: 8px;
  align-items: center;
}
.auth_wrapper .auth_content .log_in .identifiction .link_text_wrapper button span {
  color: var(--text-color-accent);
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.auth_wrapper .auth_content .log_in .identifiction .identifiction_title {
  max-width: 327px;
  color: #FFF;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
  letter-spacing: 0.4px;
  margin-bottom: 16px;
}
.auth_wrapper .auth_content .log_in .identifiction .identifiction_error, .auth_wrapper .auth_content .log_in .error {
  max-width: 327px;
  color: #b53546;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;
  letter-spacing: 0.4px;
  margin-top: 16px;
  margin-bottom: 16px;
}
.auth_wrapper .auth_content .log_in .identifiction .identifiction_description {
  max-width: 327px;
  color: #A6A4B4;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;
  margin-bottom: 30px;
}
.auth_wrapper .auth_content .log_in .identifiction .identifiction_description span {
  color: #FFF;
}
.auth_wrapper .auth_content .log_in .identifiction .main_btn {
  max-width: 335px;
  margin: 50px 0 31px;
}
.auth_wrapper .auth_content .register .step_head {
  //width: 335px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 50px 0;
}
.auth_wrapper .auth_content .register .step_head .step_head_item {
  border-radius: 2px;
  background: #3B363F;
  height: 4px;
  width: 100%;
}
.auth_wrapper .auth_content .register .step_head .step_head_item.active {
  background: var(--accent-bg);
}
.auth_wrapper .auth_content .register .step {
  display: none;
}
.auth_wrapper .auth_content .register .step.active {
  display: block;
}
.auth_wrapper .auth_content .register .step_1 .title {
  color: #FFF;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
  letter-spacing: 0.4px;
  margin-bottom: 30px;
}
.auth_wrapper .auth_content .register .step_1 .inputs {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 52px;
}
.auth_wrapper .auth_content .register .step_1 .inputs .input-row {
  display: flex;
  gap: 12px;
}
.auth_wrapper .auth_content .register .step_1 .inputs .input-row > * {
  flex: 1;
}
.auth_wrapper .auth_content .register .step_1 .inputs .section-divider {
  margin: 10px 0 5px 0;
}
.auth_wrapper .auth_content .register .step_1 .inputs .section-divider h3 {
  color: #A6A4B4;
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.auth_wrapper .auth_content .register .step_1 .main_btn {
  width: 100%;
}
.auth_wrapper .auth_content .register .step_2 .link_text_wrapper {
  margin: 25px 0 16px;
  max-width: 335px;
  display: flex;
  justify-content: center;
}
.auth_wrapper .auth_content .register .step_2 .link_text_wrapper button {
  display: flex;
  gap: 8px;
  align-items: center;
}
.auth_wrapper .auth_content .register .step_2 .link_text_wrapper button span {
  color: var(--text-color-accent);
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.auth_wrapper .auth_content .register .step_2 .identifiction_title {
  max-width: 327px;
  color: #FFF;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
  letter-spacing: 0.4px;
  margin-bottom: 16px;
}
.auth_wrapper .auth_content .register .step_2 .identifiction_description {
  max-width: 327px;
  color: #A6A4B4;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;
  margin-bottom: 30px;
}
.auth_wrapper .auth_content .register .step_2 .identifiction_description span {
  color: #FFF;
}
.auth_wrapper .auth_content .register .step_2 .main_btn {
  width: 100%;
  margin: 50px 0 31px;
}
.auth_wrapper .auth_content .register .step_3 .link_text_wrapper {
  margin: 50px 0 16px;
  max-width: 335px;
  display: flex;
  justify-content: center;
}
.auth_wrapper .auth_content .register .step_3 .link_text_wrapper button {
  display: flex;
  gap: 8px;
  align-items: center;
}
.auth_wrapper .auth_content .register .step_3 .link_text_wrapper button span {
  color: var(--text-color-accent);
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.auth_wrapper .auth_content .register .step_3 .identifiction_title {
  max-width: 327px;
  color: #FFF;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
  letter-spacing: 0.4px;
  margin-bottom: 16px;
}
.auth_wrapper .auth_content .register .step_3 .identifiction_description {
  max-width: 327px;
  color: #A6A4B4;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;
  margin-bottom: 30px;
}
.auth_wrapper .auth_content .register .step_3 .identifiction_description span {
  color: #FFF;
}
.auth_wrapper .auth_content .register .step_3 .main_btn {
  width: 100%;
  margin-top: 50px;
}
.auth_wrapper .auth_content .register .text {
  color: #6C7072;
}
.auth_wrapper .auth_content .register .error {
  color: #b53546;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;
  letter-spacing: 0.4px;
  padding: 0px 5px 0px 15px;
  margin-top: 16px;
  margin-bottom: 16px;
}
.auth_wrapper .auth_bg {
  //width: calc(50% - 11.5px - 12.5px);
  flex-basis: 100px;
  flex-grow: 1;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 16px;
}

html[owner="wca"] .auth_wrapper {
  max-width: 602px;
}

html[owner="wca"] .auth_wrapper .auth_content {
  flex-basis: auto;
  width: 100%;
}

html[owner="wca"] .auth_wrapper .auth_bg {
  display: none;
}

@media (max-width: 576px) {
  html[owner="wca"] .auth_wrapper {
    max-width: 100%;
    overflow-x: hidden;
    width: 100%;
  }

  html[owner="wca"] .auth_wrapper .auth_content,
  html[owner="wca"] .auth_wrapper .auth_content .log_in,
  html[owner="wca"] .auth_wrapper .auth_content .log_in_wrapper,
  html[owner="wca"] .auth_wrapper .auth_content .log_in .phone_input_wrapper {
    box-sizing: border-box;
    max-width: 100%;
    width: 100%;
  }

  html[owner="wca"] .auth_wrapper .auth_content {
    max-width: 100vw;
    overflow-x: hidden;
  }

  html[owner="wca"] .auth_wrapper .auth_content .log_in .phone_input_wrapper,
  html[owner="wca"] .auth_wrapper .auth_content .log_in .phone_input {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }

  html[owner="wca"] .auth_wrapper .auth_content .log_in .text {
    max-width: calc(100vw - 40px);
  }

  html[owner="wca"] .auth_wrapper .auth_content .log_in .mobile_link span {
    max-width: calc(100vw - 88px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  html[owner="wca"] .auth_wrapper .auth_content .log_in .main_btn {
    left: 20px !important;
    max-width: calc(100vw - 40px) !important;
    right: 20px;
    width: calc(100vw - 40px) !important;
  }
}

.splash {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &.stater {
    background-image: url("@/assets/images/auth/stater/auth_bg.png");
  }
  &.grok {
    background-image: url("@/assets/images/auth/grok/auth_bg.png");
  }
  &.prima {
    background-image: url("@/assets/images/auth/prima/auth_bg.png");
  }
  &.arvand {
    background-image: url("@/assets/images/auth/arvand/auth_bg.png");
  }
}
</style>
